import sidePanel from '../components/menu.svelte'
import BigPicture from 'bigpicture'
import lozad from 'lozad'
import Carousel from '../components/carousel.svelte'
import ImageGallery from '../components/image-gallery.svelte'
import TestimonialCarousel from '../components/testimonial-carousel.svelte'
import HeroHome from '../components/hero.svelte'
// import CircleList from '../components/circle-list.svelte'

const { $ } = window
const $body = $(document.body)

export default {
	init() {
		hero()

		// JavaScript to be fired on all pages
		new sidePanel({
			target: $body[0],
			props: {
				target: $body[0],
				content: document.getElementById('menu'),
				fixed: true,
				// width: 270,
				left: true,
				// preventScroll: false,
			},
		})

		// $(document).on(
		// 	'click',
		// 	'.menu-section .menu-item-has-children > a',
		// 	function (e) {
		// 		e.preventDefault()
		// 		let $el = $(this)
		// 		$el.parent().toggleClass('show-subnav')
		// 	}
		// )
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		let $article = $('.article-formatting')

		// carousel block
		carousel()

		// gallery block
		imageGallery()

		// testimonial carousel block
		testimonialCarousel()

		// circle list block
		// circleList()

		// newsletter callout form
		newsletterForm()

		// add squiggle to menu item
		addSquiggletoMenuItem()

		initLozad()

		// class to hide outlines if not using keyboard
		$body.on('mousedown', function () {
			$body.addClass('using-mouse')
		})
		$body.on('keydown', function () {
			$body.removeClass('using-mouse')
		})

		// article enlarge images
		if ($article.length) {
			$article
				.find(
					'.wp-block-image a[href*=".jpg"], .wp-block-image a[href*=".jpeg"]'
				)
				.on('click', function (e) {
					const $this = $(this)
					const $imgEls = $this.find('img')
					e.preventDefault()
					BigPicture({
						el: $imgEls.length ? $imgEls[0] : this,
						imgSrc: this.href,
					})
				})
		}
	},
}

function hero() {
	let $hero = $('#hero')
	if ($hero.length) {
		new HeroHome({
			target: $hero[0],
			props: $hero.data(),
		})
	}
}

function carousel() {
	let $carousel = $('.carousel-wrap')
	if ($carousel.length) {
		$carousel.each((i, el) => {
			new Carousel({
				target: el,
				props: $(el).data(),
			})
			// new Siema({
			// 	selector: el,
			// 	duration: 400,
			// })
		})
	}
}

function imageGallery() {
	let $gallery = $('.gallery-wrap')
	if ($gallery.length) {
		$gallery.each((i, el) => {
			new ImageGallery({
				target: el,
				props: $(el).data(),
			})
		})
	}
}

function testimonialCarousel() {
	let $carousel = $('#client_testimonials')
	if ($carousel.length) {
		new TestimonialCarousel({
			target: $carousel[0],
			props: $carousel.data(),
		})
	}
}

function newsletterForm() {
	let $form = $('#ec_form')
	if ($form.length) {
		$form.on('submit', function (e) {
			e.preventDefault()
			let name = $form.find('#name').val()
			let email = $form.find('#email').val()
			window.location = `/request-a-quote/?namefield=${name}&email=${email}`
		})
	}
}

function addSquiggletoMenuItem() {
	let $currentItem = $('#menu_links > ul > .current-menu-item > a')
	if ($currentItem.length) {
		$currentItem.append(`<div class="squiggle"></div>`)
	}
}

function initLozad() {
	if ($('.lozad').length) {
		let observer = lozad()
		observer.observe()
	}
}
